@let apiResponse = data.value(); @if (apiResponse) {
<p-table
  [value]="apiResponse.data"
  [loading]="data.isLoading()"
  [showGridlines]="true"
  stripedRows
  [scrollable]="true"
  scrollHeight="flex"
  class="p-datatable-sm lp-table"
  dataKey="id"
>
  <ng-template pTemplate="header">
    <tr>
      <th>Gældende fra</th>
      <th>Gældende til</th>
      <th>Manuel</th>
      <th>Sygdom</th>
      <th>Død</th>
      <th>Kritisk sygdom</th>
      <th>Jobscore</th>
    </tr>
  </ng-template>
  <ng-template [appTableRow]="apiResponse.data" pTemplate="body" let-item>
    <tr class="cursor-pointer" (click)="onHelbredClicked(item)">
      <td>{{ item.gaeldendeFra | date : "dd-MM-yyyy" }}</td>
      <td>{{ item.gaeldendeTil | date : "dd-MM-yyyy" }}</td>
      <td>{{ item.manueltIndtastet | boolean }}</td>
      <td>{{ item.sygdomScore | number : "1.2" }}</td>
      <td>{{ item.doedScore | number : "1.2" }}</td>
      <td>{{ item.kritiskSygdomScore | number : "1.2" }}</td>
      <td>{{ item.jobScore | number : "1.2" }}</td>
    </tr>
  </ng-template>
</p-table>

}
